import { render, staticRenderFns } from "./AddPartnerDiscountDlg.vue?vue&type=template&id=317b15bc&"
import script from "./AddPartnerDiscountDlg.vue?vue&type=script&lang=js&"
export * from "./AddPartnerDiscountDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddPartnerDiscountDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports